// extracted by mini-css-extract-plugin
module.exports = {"testButton":"TestAction_testButton__tXpub","disabled":"TestAction_disabled__1uNEP"};